import { Heading, Text, Box } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  background: ${({ background }) => background};
  color: ${({ textColor }) => textColor};
  padding-bottom: ${({ theme }) => theme.spaces[6]}px;
  ${({ theme, repeatImageRight }) => theme.below.laptop`
      margin-top: -${theme.spaces[repeatImageRight]}px;
    `}
  position: relative;
  z-index: 1;

  ${({ theme }) => theme.below.laptopML`
    .header-image {
      right: ${({ repeatImageRight }) => repeatImageRight}px;
    }
  `}

  ${({ theme }) => theme.below.laptop`
    padding-bottom: ${theme.spaces[5]}px;
  `}

  ${({ theme }) => theme.below.mobileXL`
    padding-bottom: ${theme.newSpaces.lg}px;
  `}

  .breadcrumbs {
    max-width: 1100px;
    ${({ theme }) => theme.below.laptopL`
      max-width: 998px;
    `}
  }
`

export const Title = styled(Heading)`
  align-self: start;
  font-size: ${({ theme }) => theme.fontSizes[7] + 4}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: 80px;
  margin-top: ${({ theme }) => theme.spaces[5]}px;
  padding-bottom: ${({ theme }) => theme.spaces[5]}px;
  text-transform: uppercase;
  white-space: pre-wrap;

  ${({ theme }) => theme.below.laptop`
    margin-top: ${theme.spaces[0]}px;
    padding-bottom: ${theme.spaces[4]}px;
    width: 100%;
    text-align: center;
  `}

  ${({ theme }) => theme.below.tablet`
    font-size: ${theme.fontSizes[6]}px;
    line-height: ${theme.lineHeight[3] + 1}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[5]}px;
    line-height: ${theme.lineHeight[5]}px;
  `}

  ${({ theme }) => theme.below.mobileM`
    font-size: ${theme.fontSizes[4]}px;
  `}
`

export const ContainerImage = styled(Box)`
  bottom: ${({ imageBottom }) => imageBottom}px;
  height: auto;
  max-width: ${({ width }) => width}px;
  position: absolute;
  right: ${({ imageRight }) => imageRight || 0}px;
  width: 100%;

  img {
    height: auto;
    object-fit: contain;
    width: 100%;
  }

  ${({ theme }) => theme.below.laptop`
    padding-bottom: ${theme.spaces[4]}px;
    position: static;
  `}
`

export const Description = styled(Text)`
  align-self: start;
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: 1.5;
  max-width: 571px;
  width: 100%;
  word-wrap: break-word;

  ${({ theme }) => theme.below.laptop`
    width: 100%;
    margin-bottom: 0px;
    text-align: center;
    max-width: 100%;
  `}

  ${({ theme }) => theme.below.tablet`
    font-size: ${theme.fontSizes[3]}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[2]}px;
  `}
`

export const ContentWrapper = styled(Box)`
  width: 100%;

  ${({ theme }) => theme.below.mobileXL`
    flex-direction: column-reverse;

    ${ContainerImage} {
      margin: 0 auto;
      padding-bottom: 0;
    }
  `}
`
